export enum DamageLocation {
  FRONT = "Front centre area",
  RIGHT_SIDE_FRONT = "Right front area",
  RIGHT_SIDE_MIDDLE = "Right centre area",
  RIGHT_SIDE_REAR = "Right rear area",
  BACK = "Back centre area",
  LEFT_SIDE_REAR = "Left rear area",
  LEFT_SIDE_MIDDLE = "Left centre area",
  LEFT_SIDE_FRONT = "Left front area",
  TOP = "Top of passenger area",
  UNDERCARRIAGE = "Undercarriage",
  ATTACHMENT = "Load/trailer attachment",
}
